import React from "react";
import PropTypes from "prop-types";
import { AlertCircle, Button } from "@opendate-app/setlist";
import { formatTimes } from "../ticketSets";

const TicketSetOverlaps = ({ sets, overlaps, decisions, allTimes, onDecide, onClear }) => {
  const nameOf = (key) => (sets.find((set) => set.key === key) || {}).name;
  const timesLabel = (times) => (times.length === allTimes.length ? "all entry times" : formatTimes(times));

  return (
    <>
      {overlaps.map((overlap) => (
        <div key={overlap.id} className="series-notice warning series-set-overlap" data-testid="ticket-set-overlap">
          <AlertCircle width={20} height={20} aria-hidden="true" className="series-notice-icon" />
          <div>
            <div className="series-notice-title">
              {nameOf(overlap.a)} and {nameOf(overlap.b)} both apply to {timesLabel(overlap.times)} on {overlap.dates.length} date
              {overlap.dates.length === 1 ? "" : "s"}
            </div>
            <div className="series-notice-body">Which ticket set should these entry times use?</div>
            <div className="series-set-overlap-actions">
              <Button variant="secondary" size="sm" onClick={() => onDecide(overlap.a, overlap.b)}>
                Use {nameOf(overlap.a)}
              </Button>
              <Button variant="secondary" size="sm" onClick={() => onDecide(overlap.b, overlap.a)}>
                Use {nameOf(overlap.b)}
              </Button>
            </div>
          </div>
        </div>
      ))}

      {decisions.length > 0 && (
        <ul className="series-set-decisions">
          {decisions.map(({ winner, loser }) => (
            <li key={`${winner}|${loser}`}>
              <span>
                <strong>{nameOf(winner)}</strong> wins over <strong>{nameOf(loser)}</strong> where they overlap
              </span>
              <button type="button" className="series-notice-link" onClick={() => onClear(winner, loser)}>
                Change
              </button>
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

TicketSetOverlaps.propTypes = {
  sets: PropTypes.arrayOf(PropTypes.object).isRequired,
  overlaps: PropTypes.arrayOf(PropTypes.object).isRequired,
  decisions: PropTypes.arrayOf(PropTypes.object).isRequired,
  allTimes: PropTypes.arrayOf(PropTypes.string).isRequired,
  onDecide: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

export default TicketSetOverlaps;
